import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DrawingService {
  private drawingUpdated = new BehaviorSubject<any>(null); // Emits an event every time a drawing is added
  drawingUpdated$ = this.drawingUpdated.asObservable();

  // Call this function when a drawing is added
  notifyDrawingUpdate() {
    this.drawingUpdated.next(null);
  }
}
